import { FC } from 'react';

import { BUTTON_TYPES } from '@savgroup-front-common/constants';

import { ImageConverter } from '../../helpers/ImageConverter';
import { ScanBarcodeIcon } from '../../protons/icons';
import FileUploadButton from '../FileUploadButton/FileUploadButton';

interface ScanButtonProps {
  onNewFileUpload: ({ file }: { file: File }) => void;
  isLoading?: boolean;
  acceptedMimeTypes?: string;
}

const ScanButton: FC<ScanButtonProps> = ({
  onNewFileUpload,
  isLoading,
  acceptedMimeTypes = 'image/*',
}) => {
  const handleFileSelect = async ({ file }: { file: File }) => {
    const converted = await ImageConverter.heiToJpg(file);

    onNewFileUpload({ file: converted });
  };

  return (
    <FileUploadButton
      primary
      hollow
      onFileSelect={handleFileSelect}
      icon={<ScanBarcodeIcon />}
      isLoading={isLoading}
      accept={acceptedMimeTypes}
      type={BUTTON_TYPES.BUTTON}
    />
  );
};

export default ScanButton;
